import _statistic from '~/analytics/statistics';

export const FRAME = 'login';

export default ((config: Record<string, any>) => {
  return (comp: string, action: string, params: Record<string, any>) =>
    _statistic(comp, action, { ...config, ...params });
})({ frame: FRAME });
